<template>
  <div class="swiper-container swiper5">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-bind:key="item.index" v-for="item in imgs">
        <div class="container">
          <div class="item">
            <div class="img" v-if="video_flag!=item.index">
              <img alt="xxx" :src="item.imgUrl" style="width: 100%;" />
              <div class="icon" @click="changeVideoFlag(item.index)">
                <img src="../../../assets/imgs/play2.png" style="width:100%" />
              </div>
            </div>
            <div class="img" v-if="video_flag==item.index">
              <video style="width:100%" muted autoplay="autoplay" controls="controls">
                <source :src="item.videoUrl" type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="swiper-button-prev swiper-button-black"></div>
    <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
    <div class="swiper-button-next swiper-button-black"></div>
  </div>
</template>
<script>
import Swiper from "./js/swiper.min.js";
import {
  skoda_drive_501,
  skoda_drive_502,
  skoda_drive_503,
  skoda_drive_504,
} from "../../../components/config";
export default {
  props: [],
  name: "Swiper2",
  data() {
    return {
      video_flag: 0,
      imgs: [
        {
          index: 1,
          videoUrl: skoda_drive_501,
          imgUrl: require("../../../assets/skoda-drive/imgs/515.jpg"),
        },
        {
          index: 2,
          videoUrl: skoda_drive_502,
          imgUrl: require("../../../assets/skoda-drive/imgs/513.jpg"),
        },
        {
          index: 3,
          videoUrl: skoda_drive_503,
          imgUrl: require("../../../assets/skoda-drive/imgs/516.jpg"),
        },
        {
          index: 4,
          videoUrl: skoda_drive_504,
          imgUrl: require("../../../assets/skoda-drive/imgs/514.jpg"),
        },
      ],
    };
  },
  methods: {
    initSwiper() {
      const swip = new Swiper(".swiper5", {
        slidesPerView: 1.3,
        slidesPerGroup: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    },
    changeVideoFlag(index) {
      if (index == 1) {
        this.video_flag = 1;
      } else if (index == 2) {
        this.video_flag = 2;
      } else if (index == 3) {
        this.video_flag = 3;
      } else if (index == 4) {
        this.video_flag = 4;
      }
    },
  },
  created() {},
  mounted() {
    this.initSwiper();
  },
};
</script>
<style scoped>
@import url("./css/swiper.min.css");

.swiper-container {
  position: relative;
  width: 100%;
}
.container {
  position: relative;
  width: 100%;
}
.container .item {
  width: 100%;
}
.icon {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 40px;
  height: 40px;
  margin-left: -20px;
  margin-top: -20px;
  cursor: pointer;
}
@media screen and (min-width: 1px) {
  .swiper-button-black {
    --swiper-navigation-size: 20px; /* 设置按钮大小 */
    color: rgba(255, 255, 255, 1);
    background: rgba(0, 0, 0, 0.7);
    border-radius: 2px;
    width: 15px;
    height: 30px;
    padding: 2px;
  }
}
@media screen and (min-width: 1px) and (max-width: 1300px) {
}
@media screen and (min-width: 1301px) and (max-width: 1600px) {
}
</style>
